/*
 * © Copyright 2014 - 2022 Micro Focus or one of its affiliates.
 *
 * The only warranties for products and services of Micro Focus and its affiliates and licensors ("Micro Focus") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Micro Focus shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import t from '../../../i18n/locale-keys';
import PropTypes from 'prop-types';
import { captureButtonID, captureInstClass } from '../../../api/devices/facial-device.api';
 
function getfacialInstructions() {
    return (
        <div className={captureInstClass}>
            <ul className='device-ser-inst'>
                <li>{t.devServiceCaptInst1()}</li>
                <li>{t.devServiceCaptInst2()}</li>
                <li>{t.devServiceCaptInst3()}</li>
                <li>{t.devServiceCaptInst4()}</li>
            </ul>
            <ul className='browser-api-inst'>
                <li>{t.browserAPIInst1()}</li>
                <li>{t.browserAPIInst2()}</li>
                <li>{t.browserAPIInst3()}</li>
            </ul>
        </div>);
}


function FacialVideo({ captureDone, imgSrc, showFace, facialVideoKey, height, width }) {
    const feedStyle = {
        display: showFace ? 'block' : 'none'
    };

    // Get the height and width for canvas to draw face-oval/rectangle , otherwise set to default
    const canvasDimensions = {
        height: height || 400,
        width: width || 400
    };

    let feedElement;
    if (imgSrc) {
        feedElement = (
            <div id="faceImgContainer">
                <img alt={t.face()} id="faceImg" src={imgSrc} />
            </div>
        );
    }
    else {
        feedElement = (
            <div>
                <canvas id={'canvasSnap' + facialVideoKey} />
                <video id={'video' + facialVideoKey} preload="none" autoPlay muted style={feedStyle} />
                <canvas id={'canvas' + facialVideoKey} style={feedStyle} width={canvasDimensions.width} height={canvasDimensions.height} />
                {!captureDone && showFace &&
                    <div className='capture-btn-sec' style={{ 'width': canvasDimensions.width + 'px' }}>
                        <button
                            className="ias-button test-btn-hide"
                            id={captureButtonID} 
                            type="button"
                            disabled={false}
                        > {t.capture()}</button>
                    </div>
                }
                

            </div>
        );
    }

    let doneIcon = null;
    if (captureDone) {
        doneIcon = (
            <div className="done-icon">
                <i className="ias-icon ias-icon-facial_recognition" />
                <p>Image captured</p>
            </div>
        );
    }

    return (
       <div>
           {!captureDone && getfacialInstructions()}
        <div className="facial-video">
                {feedElement}
                {doneIcon}
        </div>
        </div>
    );
}

FacialVideo.propTypes = {
    captureDone: PropTypes.bool.isRequired,
    facialVideoKey: PropTypes.string.isRequired,
    imgSrc: PropTypes.string,
    showFace: PropTypes.bool.isRequired
};

export default FacialVideo;